module.exports = __webpack_public_path__ + "static/media/PhD.655e5e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Static/PhD.jpg
// module id = 28
// module chunks = 1